var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 197.16,
    height: 159.413,
    viewBox: "0 0 197.16 159.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1752",
    "data-name": "Group 1752",
    transform: "translate(-10162 -6594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-36",
    transform: "translate(10162 6594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10695",
    "data-name": "Path 10695",
    d: "M220.1,112.789s-29.453-16.475-63.246-3.955-55.33,45.087-73.45,71.026S68.041,235.8,89.3,252.881s40.522.508,73.636,5.175,41.177,10.882,71.693-3.079,42.94-57.065,26.928-93.225S220.1,112.789,220.1,112.789Z",
    transform: "translate(-71.407 -104.137)",
    fill: "#64b5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10696",
    "data-name": "Path 10696",
    d: "M220.1,112.789s-29.453-16.475-63.246-3.955-55.33,45.087-73.45,71.026S68.041,235.8,89.3,252.881s40.522.508,73.636,5.175,41.177,10.882,71.693-3.079,42.94-57.065,26.928-93.225S220.1,112.789,220.1,112.789Z",
    transform: "translate(-71.407 -104.137)",
    fill: "#fff",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Calendar--inject-36",
    transform: "translate(10200.309 6630.151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1673",
    "data-name": "Rectangle 1673",
    width: 133.178,
    height: 88.485,
    rx: 6,
    transform: "translate(0 6.195)",
    fill: "#64b5f6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1674",
    "data-name": "Rectangle 1674",
    width: 133.178,
    height: 88.485,
    rx: 6,
    transform: "translate(0 6.195)",
    fill: "#64b5f6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1675",
    "data-name": "Rectangle 1675",
    width: 15.581,
    height: 8.741,
    transform: "translate(40.59 55.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1676",
    "data-name": "Rectangle 1676",
    width: 15.581,
    height: 8.741,
    transform: "translate(40.59 65.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1677",
    "data-name": "Rectangle 1677",
    width: 15.581,
    height: 8.741,
    transform: "translate(57.756 55.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1678",
    "data-name": "Rectangle 1678",
    width: 15.581,
    height: 8.741,
    transform: "translate(74.926 45.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1679",
    "data-name": "Rectangle 1679",
    width: 15.581,
    height: 8.741,
    transform: "translate(74.926 35.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1680",
    "data-name": "Rectangle 1680",
    width: 15.581,
    height: 7.173,
    transform: "translate(74.926 15.93)",
    fill: "#c5f2e8",
    stroke: "#707070",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1681",
    "data-name": "Rectangle 1681",
    width: 15.581,
    height: 7.173,
    transform: "translate(57.756 15.93)",
    fill: "#c5f2e8",
    stroke: "#707070",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1682",
    "data-name": "Rectangle 1682",
    width: 15.581,
    height: 8.741,
    transform: "translate(57.756 65.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1683",
    "data-name": "Rectangle 1683",
    width: 15.581,
    height: 8.741,
    transform: "translate(57.756 24.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1684",
    "data-name": "Rectangle 1684",
    width: 15.581,
    height: 8.741,
    transform: "translate(57.756 35.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1685",
    "data-name": "Rectangle 1685",
    width: 15.581,
    height: 8.741,
    transform: "translate(57.756 45.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1686",
    "data-name": "Rectangle 1686",
    width: 15.581,
    height: 8.741,
    transform: "translate(74.926 65.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1687",
    "data-name": "Rectangle 1687",
    width: 16.611,
    height: 8.741,
    transform: "translate(5.224 24.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1688",
    "data-name": "Rectangle 1688",
    width: 16.611,
    height: 8.741,
    transform: "translate(5.224 45.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1689",
    "data-name": "Rectangle 1689",
    width: 16.611,
    height: 8.741,
    transform: "translate(5.224 55.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1690",
    "data-name": "Rectangle 1690",
    width: 16.611,
    height: 8.741,
    transform: "translate(5.224 35.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1691",
    "data-name": "Rectangle 1691",
    width: 16.611,
    height: 7.173,
    transform: "translate(109.263 15.93)",
    fill: "#c5f2e8",
    stroke: "#707070",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1692",
    "data-name": "Rectangle 1692",
    width: 16.611,
    height: 8.741,
    transform: "translate(5.224 65.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1693",
    "data-name": "Rectangle 1693",
    width: 15.581,
    height: 8.741,
    transform: "translate(92.092 24.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1694",
    "data-name": "Rectangle 1694",
    width: 15.581,
    height: 8.741,
    transform: "translate(74.926 55.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1695",
    "data-name": "Rectangle 1695",
    width: 15.581,
    height: 8.741,
    transform: "translate(92.092 55.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1696",
    "data-name": "Rectangle 1696",
    width: 15.581,
    height: 8.741,
    transform: "translate(92.092 35.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1697",
    "data-name": "Rectangle 1697",
    width: 15.581,
    height: 8.741,
    transform: "translate(92.092 45.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1698",
    "data-name": "Rectangle 1698",
    width: 15.581,
    height: 8.741,
    transform: "translate(92.092 65.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1699",
    "data-name": "Rectangle 1699",
    width: 15.581,
    height: 8.741,
    transform: "translate(74.926 24.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1700",
    "data-name": "Rectangle 1700",
    width: 16.611,
    height: 8.741,
    transform: "translate(109.263 65.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1701",
    "data-name": "Rectangle 1701",
    width: 15.581,
    height: 7.173,
    transform: "translate(92.092 15.93)",
    fill: "#c5f2e8",
    stroke: "#707070",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1702",
    "data-name": "Rectangle 1702",
    width: 16.611,
    height: 8.741,
    transform: "translate(109.263 55.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1703",
    "data-name": "Rectangle 1703",
    width: 15.581,
    height: 9.238,
    transform: "translate(92.092 76.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1704",
    "data-name": "Rectangle 1704",
    width: 16.611,
    height: 8.741,
    transform: "translate(109.263 45.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1705",
    "data-name": "Rectangle 1705",
    width: 15.581,
    height: 9.238,
    transform: "translate(57.756 76.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1706",
    "data-name": "Rectangle 1706",
    width: 15.581,
    height: 9.238,
    transform: "translate(74.926 76.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1707",
    "data-name": "Rectangle 1707",
    width: 16.611,
    height: 8.741,
    transform: "translate(109.263 35.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1708",
    "data-name": "Rectangle 1708",
    width: 16.611,
    height: 9.238,
    transform: "translate(109.263 76.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1709",
    "data-name": "Rectangle 1709",
    width: 16.611,
    height: 9.238,
    transform: "translate(5.224 76.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1710",
    "data-name": "Rectangle 1710",
    width: 16.611,
    height: 8.741,
    transform: "translate(109.263 24.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1711",
    "data-name": "Rectangle 1711",
    width: 16.611,
    height: 7.173,
    transform: "translate(5.224 15.93)",
    fill: "#c5f2e8",
    stroke: "#707070",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1712",
    "data-name": "Rectangle 1712",
    width: 15.581,
    height: 7.173,
    transform: "translate(23.419 15.93)",
    fill: "#c5f2e8",
    stroke: "#707070",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1713",
    "data-name": "Rectangle 1713",
    width: 15.581,
    height: 8.741,
    transform: "translate(23.419 55.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1714",
    "data-name": "Rectangle 1714",
    width: 15.581,
    height: 7.173,
    transform: "translate(40.59 15.93)",
    fill: "#c5f2e8",
    stroke: "#707070",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1715",
    "data-name": "Rectangle 1715",
    width: 15.581,
    height: 8.741,
    transform: "translate(40.59 35.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1716",
    "data-name": "Rectangle 1716",
    width: 15.581,
    height: 8.741,
    transform: "translate(23.419 65.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1717",
    "data-name": "Rectangle 1717",
    width: 15.581,
    height: 8.741,
    transform: "translate(40.59 24.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1718",
    "data-name": "Rectangle 1718",
    width: 15.581,
    height: 8.741,
    transform: "translate(23.419 24.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1719",
    "data-name": "Rectangle 1719",
    width: 15.581,
    height: 8.741,
    transform: "translate(40.59 45.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1720",
    "data-name": "Rectangle 1720",
    width: 15.581,
    height: 8.741,
    transform: "translate(23.419 45.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1721",
    "data-name": "Rectangle 1721",
    width: 15.581,
    height: 9.238,
    transform: "translate(23.419 76.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1722",
    "data-name": "Rectangle 1722",
    width: 15.581,
    height: 8.741,
    transform: "translate(23.419 35.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1723",
    "data-name": "Rectangle 1723",
    width: 15.581,
    height: 9.238,
    transform: "translate(40.59 76.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_549",
    "data-name": "Ellipse 549",
    cx: 2.245,
    cy: 2.245,
    r: 2.245,
    transform: "translate(10.31 6.618)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10701",
    "data-name": "Path 10701",
    d: "M156.38,119.045a2.25,2.25,0,1,0-2.245,2.245A2.25,2.25,0,0,0,156.38,119.045Z",
    transform: "translate(-133.98 -110.183)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10702",
    "data-name": "Path 10702",
    d: "M140.788,114.606h0a1.178,1.178,0,0,1-1.178-1.178v-7.965a1.178,1.178,0,0,1,1.178-1.183h0a1.183,1.183,0,0,1,1.183,1.183v7.965a1.178,1.178,0,0,1-1.183,1.178Z",
    transform: "translate(-128.191 -104.28)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10703",
    "data-name": "Path 10703",
    d: "M155.308,114.606h0a1.178,1.178,0,0,1-1.178-1.178v-7.965a1.178,1.178,0,0,1,1.178-1.183h0a1.183,1.183,0,0,1,1.183,1.183v7.965a1.178,1.178,0,0,1-1.183,1.178Z",
    transform: "translate(-135.042 -104.28)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10704",
    "data-name": "Path 10704",
    d: "M333.9,119.045a2.25,2.25,0,1,0-2.245,2.245,2.25,2.25,0,0,0,2.245-2.245Z",
    transform: "translate(-217.739 -110.183)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_550",
    "data-name": "Ellipse 550",
    cx: 2.245,
    cy: 2.245,
    r: 2.245,
    transform: "translate(119.266 6.618)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10705",
    "data-name": "Path 10705",
    d: "M332.688,114.606h0a1.178,1.178,0,0,1-1.178-1.178v-7.965a1.178,1.178,0,0,1,1.178-1.183h0a1.183,1.183,0,0,1,1.183,1.183v7.965a1.178,1.178,0,0,1-1.183,1.178Z",
    transform: "translate(-218.735 -104.28)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10706",
    "data-name": "Path 10706",
    d: "M347.2,114.606h0a1.178,1.178,0,0,1-1.2-1.178v-7.965a1.183,1.183,0,0,1,1.183-1.183h0a1.178,1.178,0,0,1,1.178,1.183v7.965a1.178,1.178,0,0,1-1.162,1.178Z",
    transform: "translate(-225.572 -104.28)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_551",
    "data-name": "Ellipse 551",
    cx: 2.245,
    cy: 2.245,
    r: 2.245,
    transform: "translate(60.993 6.618)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_552",
    "data-name": "Ellipse 552",
    cx: 2.245,
    cy: 2.245,
    r: 2.245,
    transform: "translate(68.588 6.618)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10707",
    "data-name": "Path 10707",
    d: "M236.738,114.606h0a1.178,1.178,0,0,1-1.178-1.178v-7.965a1.178,1.178,0,0,1,1.178-1.183h0a1.183,1.183,0,0,1,1.183,1.183v7.965a1.178,1.178,0,0,1-1.183,1.178Z",
    transform: "translate(-173.463 -104.28)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10708",
    "data-name": "Path 10708",
    d: "M251.258,114.606h0a1.178,1.178,0,0,1-1.178-1.178v-7.965a1.178,1.178,0,0,1,1.178-1.183h0a1.183,1.183,0,0,1,1.183,1.183v7.965a1.178,1.178,0,0,1-1.183,1.178Z",
    transform: "translate(-180.314 -104.28)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_764",
    "data-name": "Line 764",
    x1: 7.859,
    y2: 6.93,
    transform: "translate(8.15 35.773)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_765",
    "data-name": "Line 765",
    x2: 5.44,
    y2: 6.465,
    transform: "translate(10.569 35.773)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_766",
    "data-name": "Line 766",
    x1: 7.859,
    y2: 6.924,
    transform: "translate(95.134 25.917)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_767",
    "data-name": "Line 767",
    x2: 5.44,
    y2: 6.465,
    transform: "translate(97.553 25.917)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1753",
    "data-name": "Group 1753"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_768",
    "data-name": "Line 768",
    x1: 7.864,
    y2: 6.924,
    transform: "translate(46.491 25.917)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_769",
    "data-name": "Line 769",
    x2: 3.47,
    y2: 3.714,
    transform: "translate(43.021 29.128)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_770",
    "data-name": "Line 770",
    x1: 7.864,
    y2: 6.93,
    transform: "translate(113.108 25.722)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_771",
    "data-name": "Line 771",
    x2: 5.445,
    y2: 6.465,
    transform: "translate(115.527 25.722)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1754",
    "data-name": "Group 1754",
    transform: "translate(0 30.655)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_768-2",
    "data-name": "Line 768",
    x1: 7.864,
    y2: 6.924,
    transform: "translate(46.491 25.917)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_769-2",
    "data-name": "Line 769",
    x2: 3.47,
    y2: 3.714,
    transform: "translate(43.021 29.128)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1755",
    "data-name": "Group 1755",
    transform: "translate(51.194 30.792)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_768-3",
    "data-name": "Line 768",
    x1: 7.864,
    y2: 6.924,
    transform: "translate(46.491 25.917)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_769-3",
    "data-name": "Line 769",
    x2: 3.47,
    y2: 3.714,
    transform: "translate(43.021 29.128)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1756",
    "data-name": "Group 1756",
    transform: "translate(34.029 51.438)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_768-4",
    "data-name": "Line 768",
    x1: 7.864,
    y2: 6.924,
    transform: "translate(46.491 25.917)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_769-4",
    "data-name": "Line 769",
    x2: 3.47,
    y2: 3.714,
    transform: "translate(43.021 29.128)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEvents);
export default __webpack_public_path__ + "static/media/noEvents.9552046fdc6cb097f3f6a03d93f65b49.svg";
export { ForwardRef as ReactComponent };